import { render, staticRenderFns } from "./V2ProductVariants.vue?vue&type=template&id=78d072ce&scoped=true&"
import script from "./V2ProductVariants.vue?vue&type=script&lang=js&"
export * from "./V2ProductVariants.vue?vue&type=script&lang=js&"
import style0 from "./V2ProductVariants.vue?vue&type=style&index=0&id=78d072ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d072ce",
  null
  
)

export default component.exports